import React from 'react';

import { AppSiteFooter } from '~/app/components/common/AppSiteFooter/AppSiteFooter';
import { Side } from '~/app/components/sideBar/SidebarNav';
import { HEADER_HEIGHT, LANDING_MAIN_GUTTER_PX } from './layout.constants';

type LandingMainShellProps = {
  collapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  header: React.ReactNode;
  routedContent: React.ReactNode;
};

export function LandingMainShell({
  collapsed,
  onCollapsedChange,
  header,
  routedContent,
}: LandingMainShellProps) {
  return (
    <>
      <div className="landing-app-body">
        <Side collapsed={collapsed} onCollapsedChange={onCollapsedChange} />

        <div
          className="landing-main-column"
          style={
            {
              '--landing-main-gutter': `${LANDING_MAIN_GUTTER_PX}px`,
              '--evimo-table-viewport-offset': `${HEADER_HEIGHT + 168}px`,
            } as React.CSSProperties
          }
        >
          <div className="landing-main-pane">
            {header}

            <div className="landing-content-scroll">
              <div className="landing-page-root">{routedContent}</div>
            </div>
          </div>
        </div>
      </div>

      <AppSiteFooter />
    </>
  );
}
